<div class="padding-16">
    <div class="description">
        <h2 class="header"><b>Welcome to the Lidoma Platform!</b></h2>
        It seems you’re using an in-app browser.
        For the best experience and to continue using our website, please tap the <b>"Open in Browser"</b> button.</div>

    <button class="button button--primary button--full-width" type="button" (click)="openInBrowser()">Open In Browser</button>
    <button class="button button--primary button--full-width" type="button" (click)="copyLink()">Copy Link</button>

</div>
